<template>
  <section class="banner-swiper">
    <div class="banner-wrapper">
      <template v-if="banners.length">
        <div
          v-for="(banner, index) in banners"
          :key="banner.id"
          class="banner-slide"
          :class="{ 'banner-slide--active': index === currentIndex }"
          @click="openLink(banner.link)"
        >
          <img :src="banner.img || 'https://picsum.photos/1200/450?random=' + banner.id" :alt="banner.alt">
          <div class="banner-overlay">
            <div class="banner-title">{{ banner.alt || '广告' }}</div>
          </div>
        </div>
        <div class="banner-controls">
          <button class="banner-arrow banner-arrow--left" @click.stop="onPrevClick">‹</button>
          <button class="banner-arrow banner-arrow--right" @click.stop="onNextClick">›</button>
        </div>
        <div class="dots">
          <button
            v-for="(banner, index) in banners"
            :key="banner.id"
            class="dot"
            :class="{ 'dot--active': index === currentIndex }"
            @click="go(index)"
          />
        </div>
      </template>
      <div v-else class="banner-empty">
        <p>暂无广告</p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BannerSwiper',
  data() {
    return {
      currentIndex: 0,
      intervalId: null,
      touchStartX: 0,
      touchEndX: 0
    }
  },
  watch: {
    banners: {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.currentIndex = 0
          this.start()
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['getBannersList']),
    banners() {
      return Array.isArray(this.getBannersList) ? this.getBannersList : []
    }
  },
  mounted() {
    if (this.banners.length > 0) {
      this.start()
    }
    this.$el.addEventListener('touchstart', this.handleTouchStart, false)
    this.$el.addEventListener('touchend', this.handleTouchEnd, false)
  },
  beforeDestroy() {
    this.stop()
    this.$el.removeEventListener('touchstart', this.handleTouchStart, false)
    this.$el.removeEventListener('touchend', this.handleTouchEnd, false)
  },
  methods: {
    start() {
      this.stop()
      if (this.banners.length < 1) return
      this.intervalId = window.setInterval(() => this.next(), 7000)
    },
    stop() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId)
        this.intervalId = null
      }
    },
    next() {
      const length = this.banners.length
      if (!length) return
      this.currentIndex = (this.currentIndex + 1) % length
    },
    prev() {
      const length = this.banners.length
      if (!length) return
      this.currentIndex = (this.currentIndex - 1 + length) % length
    },
    go(index) {
      this.currentIndex = index
      this.start()
    },
    onPrevClick() {
      this.prev()
      this.start()
    },
    onNextClick() {
      this.next()
      this.start()
    },
    openLink(link) {
      if (!link) return
      window.open(link, '_blank')
    },
    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX
    },
    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX
      this.handleSwipe()
    },
    handleSwipe() {
      const diff = this.touchStartX - this.touchEndX
      const threshold = 50
      if (Math.abs(diff) > threshold) {
        if (diff > 0) this.next()
        else this.prev()
        this.start()
      }
    }
  }
}
</script>

<style scoped>
.banner-swiper {
  width: 100%;
  background: linear-gradient(180deg, #e0f2fe 0%, #f4f8fc 100%);
  padding: 20px 16px 8px;
}

.banner-wrapper {
  max-width: 1120px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid #cfe0f0;
  box-shadow: 0 14px 36px rgba(2, 132, 199, 0.12);
  aspect-ratio: 16 / 6;
  background: #fff;
}

.banner-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transform: scale(1.02);
  transition: opacity 0.6s ease, transform 0.6s ease;
  cursor: pointer;
  z-index: 0;
  pointer-events: none;
}

.banner-slide--active {
  opacity: 1;
  transform: scale(1);
  z-index: 1;
  pointer-events: auto;
}

.banner-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-overlay {
  position: absolute;
  left: 24px;
  bottom: 24px;
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.92);
  color: #0284c7;
  max-width: 420px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
}

.banner-title {
  font-size: 20px;
  font-weight: 700;
}

.banner-controls {
  position: absolute;
  inset: 0;
  z-index: 10;
  pointer-events: none;
}

.banner-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 11;
  pointer-events: auto;
  width: 40px;
  height: 40px;
  border-radius: 999px;
  border: 1px solid #cfe0f0;
  background: rgba(255, 255, 255, 0.95);
  color: #0284c7;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.banner-arrow--left { left: 16px; }
.banner-arrow--right { right: 16px; }

.banner-arrow:hover {
  background: #0284c7;
  color: #fff;
}

.dots {
  position: absolute;
  left: 50%;
  bottom: 14px;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 12;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  border: none;
  background: rgba(148, 163, 184, 0.7);
  cursor: pointer;
}

.dot--active {
  width: 18px;
  background: #f43f5e;
}

.banner-empty {
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
}

@media (max-width: 768px) {
  .banner-wrapper {
    aspect-ratio: 16 / 9;
    border-radius: 14px;
  }
  .banner-overlay {
    left: 12px;
    right: 12px;
    bottom: 12px;
    max-width: none;
  }
  .banner-title { font-size: 15px; }
}
</style>
